import { data } from "@/components/Overview/chartConfig";
import { makeApiCall, makeApiCallWithImages } from "../apiRequest";

export default {
  state: {
    allDepartment: [],
    departmentById: [],
    departmentByMaintenance: [],
  },
  getters: {
    getAllDepartment: (state) => state.allDepartment,
    getAllDepartmentMaintenance: (state) => state.departmentByMaintenance,
    getDepartmentById: (state) => state.departmentById,
  },
  actions: {
    async getAllDepartment({ commit }, obj) {
      let url = `departments/getAll`;
      const response = await makeApiCall(url, "POST", obj);
      if (!response.error) {
        commit("setAllDepartment", response.data);
      }
      return response;
    },
    async getAllDepartmentMaintenance({ commit }, obj) {
      let url = `maintenanceTasks/getMaintenanceDepartment`;
      const response = await makeApiCall(url, "GET", obj);
      if (!response.error) {
        commit("setAllDepartmentMaintenance", response.data);
      }
      return response;
    },
    async createDepartment({ commit }, payload) {
      const response = await makeApiCall("departments/save", "POST", payload);
      return response;
    },
    async deleteDepartment({ commit }, payload) {
      const response = await makeApiCall(
        `departments/delete`,
        "DELETE",
        payload
      );
      return response;
    },
    async getDepartmentById({ commit }, id) {
      const response = await makeApiCallWithImages(
        `Departments/GetDepartmentById?id=${id}`,
        "GET"
      );
      if (!response.error) {
        commit("setDepartmentById", response.data.data);
      }
    },
  },
  mutations: {
    setAllDepartment: (state, payload) => (state.allDepartment = payload),
    setDepartmentById: (state, payload) => (state.departmentById = payload),
    setAllDepartmentMaintenance: (state, payload) => (state.departmentByMaintenance = payload),
  },
};
